module.exports = __webpack_public_path__ + "static/media/like-1.908f7907.svg";